export const SUPERVISOR_REVIEW_TAB_KEY = 'supervisor-review';
